import { observer } from 'mobx-react';
import React, { useEffect, useState, useRef } from 'react';
import { TransformWrapper, TransformComponent } from 'react-zoom-pan-pinch';

const ImageTemplate = observer(({ viewStore }) => {
	const { isOpen, images = [] } = viewStore;
	const [currentIndex, setCurrentIndex] = useState(0);
	const [rotation, setRotation] = useState(0);
	const transformRef = useRef(null);

	// Close modal on Esc and navigate images with arrows
	useEffect(() => {
		const handleKeyDown = e => {
			if (!isOpen) return;
			if (e.key === 'Escape') viewStore.closeModal();
			if (e.key === 'ArrowLeft') prevImage();
			if (e.key === 'ArrowRight') nextImage();
		};
		window.addEventListener('keydown', handleKeyDown);
		return () => window.removeEventListener('keydown', handleKeyDown);
	}, [isOpen, currentIndex]);

	if (!isOpen || images.length === 0) return null;

	const currentImage = images[currentIndex];

	const rotateLeft = () => setRotation(prev => prev - 90);
	const rotateRight = () => setRotation(prev => prev + 90);

	const prevImage = () => {
		setCurrentIndex(prev => (prev - 1 + images.length) % images.length);
		setRotation(0); // reset rotation per image
	};

	const nextImage = () => {
		setCurrentIndex(prev => (prev + 1) % images.length);
		setRotation(0); // reset rotation per image
	};

	return (
		<div className="image" onClick={() => viewStore.closeModal()}>
			<div className="image__container" onClick={e => e.stopPropagation()}>
				<button className="image__close-button" onClick={() => viewStore.closeModal()}>
					✕
				</button>

				{/* Navigation buttons */}
				{images.length > 1 && (
					<React.Fragment>
						<button className="image__nav-button image__nav-button--prev" onClick={prevImage}>
							‹
						</button>
						<button className="image__nav-button image__nav-button--next" onClick={nextImage}>
							›
						</button>
					</React.Fragment>
				)}

				{/* Rotate buttons */}
				<div className="image__rotate-buttons">
					<button onClick={rotateLeft}>⟲ Rotate Left</button>
					<button onClick={rotateRight}>⟳ Rotate Right</button>
				</div>

				{/* Zoomable and draggable image */}
				<TransformWrapper
					ref={transformRef}
					initialScale={1}
					minScale={0.5}
					maxScale={5}
					wheel={{ step: 0.1 }}
					pinch={{ step: 5 }}
					doubleClick={{ disabled: true }}
					centerOnInit
				>
					<TransformComponent>
						<img
							className="image__img"
							src={currentImage}
							alt={`Image ${currentIndex + 1}`}
							style={{ transform: `rotate(${rotation}deg)` }}
						/>
					</TransformComponent>
				</TransformWrapper>
			</div>
		</div>
	);
});

export default ImageTemplate;
